import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

const SmallLoader = ({ center = false, MT = "", smallSize = false }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: center ? "center" : "unset",
          marginTop: MT ? MT + "px" : "",
        }}
      >
        <CircularProgress className="SmallLoader" size={smallSize ? 20 : 40} />
      </Box>
    </>
  );
};

export default SmallLoader;
